import FinanceKeyObject from './finance-product-objects/finance-key-object';
import FinanceProduct from './finance-product-objects/finance-product';
import NewVehicleObject from './vehicle-objects/new-vehicle-object';
/**
 * A class representing a Codeweavers v2 finance response
 */
export default class {
    /**
     *
     * @param {object} quote Response from Codeweavers
     * @param {object} financeRequest The original request object sent to CW
     * @param {NewVehicleObject} vehicleObject The vehicle object we're interested in
     * @param {FinanceKeyObject} financeKeyObject  The finance key object we're interested in
     */
    constructor(quote, financeRequest, vehicleObject, financeKeyObject) {
        this.quote = quote;
        // this.quote = JSON.parse(JSON.stringify(quote));
        this.financeRequest = financeRequest;
        this.vehicleObject = null;
        this.setVehicle(vehicleObject);
        this.financeKeyObject = financeKeyObject;
        this.vehicle = this.getVehicleFromResponse();
    }

    setFinanceKeyObject(financeKeyObject) {
        if (!financeKeyObject instanceof FinanceKeyObject) {
            throw new Error("setFinanceKeyObject must be passed an instance of FinanceKeyObject");
        }
        this.financeKeyObject = financeKeyObject;
    }

    setVehicle(vehicleObject) {
        if (!vehicleObject instanceof NewVehicleObject) {
            throw new Error("setVehicle must be passed an instance of NewVehicleObject");
        }
        this.vehicleObject = vehicleObject;
    }

    getVehicleFromResponse() {
        if (typeof this.quote.VehicleResults == 'undefined') {
            return false;
        }

        if (this.quote.VehicleResults.length == 0) {
            return false;
        }
        let vehicle = {
            FinanceProductResults: [],
            Id: this.vehicleObject.id,
        };
        this.quote.VehicleResults.forEach(element => {
            if (typeof element.Id == 'undefined') {
                return;
            }
            // If the vehicle has differing CashPrice values depending on the finance type, we have to submit the same vehicle multiple times in the request
            // We do this by taking the vehicle ID and adding _{vehicle.price} onto it
            // The below code will remove that extra price again, so we can check if it matches the ID of the vehicle we're looking
            let elementId = element.Id;
            if (typeof elementId == 'string') {
                const splitPoint = elementId.indexOf('_');
                if (splitPoint >= 0) {
                    elementId = elementId.substr(0,splitPoint);
                }
            }
            if (elementId == this.vehicleObject.id) {
                element.FinanceProductResults.forEach(financeProductResult => {
                    financeProductResult.id = element.Id;
                    vehicle.FinanceProductResults.push(financeProductResult);
                });
            }
        });
        this.vehicle = vehicle;
        return this.vehicle;
    }

    /**
     * @returns FinanceProduct
     */
    getFinanceProductOfInterest() {
        if (!this.vehicle) {
            return false;
        }
        if (typeof this.vehicle.FinanceProductResults == 'undefined') {
            return false;
        }
        let financeProduct = false;
        this.vehicle.FinanceProductResults.forEach(element => {
            if (typeof element.Key == 'undefined') {
                return;
            }
            if (element.Key == this.financeKeyObject.key) {
                financeProduct = element;
            }
        });
        return new FinanceProduct(financeProduct);
    }

    isValid() {
        if (!this.vehicle) {
            return false;
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/finance/codeweavers-response.js